import React from 'react';
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Achievement = () => {
    return (
        <div>
            <img className="w-50 mt-5 pt-5" src="https://i.ibb.co/2Y2xqBP/programming-Hero-Certificate.png"></img>
        </div>
    );
}; 

export default Achievement;